import { useMetaTags } from "react-metatags-hook";
import { useSearchParams } from "react-router";
import { TiltifyPreviousYearsTotals } from "@/components/charity/tiltify/tiltify-previous-years-totals";
import TiltifySetup from "@/components/overlays/social/tiltify/tiltify-setup";
import { TiltifyProfileCard } from "@/components/shared/cards/tiltify-profile.card";
import useTiltifyConfig from "@/hooks/useTiltifyConfig";
import { defaultOpenGraphImage, isTestMode } from "@/util/const";
export default function ProfilePage() {
  useMetaTags(
    {
      title: `Profile | ${isTestMode ? "" : "St. Jude "}Play Live Tools`,
      description: "View your Play Live Profile Page",
      openGraph: {
        image: defaultOpenGraphImage,
        description: "View your Play Live Profile Page",
      },
    },
    [],
  );

  const [searchParams] = useSearchParams();
  const overrideUserSlug = searchParams.get("overrideUserSlug");

  const { config: tiltifyConfig } = useTiltifyConfig();

  // Everything on this page is scoped to a Tiltify user, so without a slug
  // there is nothing to render but the sign-in prompt.
  const slug = (overrideUserSlug || tiltifyConfig.tiltifyUserSlug || "").trim() || null;

  if (!slug) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center gap-4 p-6 text-center">
        <h1 className="text-xl font-semibold">Sign in to Tiltify to see your profile</h1>
        <TiltifySetup />
      </div>
    );
  }

  return (
    <div className="flex items-center flex-col justify-center w-full h-full mt-24 gap-6">
      <TiltifyProfileCard overrideUserSlug={overrideUserSlug} />

      <div className="max-w-[80%] mb-4">
        <TiltifyPreviousYearsTotals overrideUserSlug={overrideUserSlug} />
      </div>
    </div>
  );
}
